import { render } from "./Kredit.vue?vue&type=template&id=09bf5932"
import script from "./Kredit.vue?vue&type=script&lang=js"
export * from "./Kredit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__